/**
 * Verifica se l'evento di verifica sull'elemento node.
 */
const doesNodeContainClick = (node, event) => node && node.contains(event.target);

export { doesNodeContainClick as default };
